export default __webpack_public_path__ + "static/media/Crowd2.c8bb9ec5.PNG";